import React from 'react';
import { useDispatch } from 'react-redux';
import { SchoolForm } from 'features/schools/SchoolForm';
import MantineProvider from 'providers/MantineProvider';
import { schoolsActions } from 'store/actions/actions';

// Legacy pages keep snake_case data in Redux. Only adapt the read model here;
// the shared form owns validation, uploads and every create/edit API call.
const EditSchoolModal = ({ school, hide, onUpdated = () => {} }) => {
  const dispatch = useDispatch();
  return (
    <MantineProvider>
      <SchoolForm
        modalProps={{ opened: true, onClose: hide }}
        schoolToEdit={{
          organizationType: school.organization_type,
          schoolName: school.school_name,
          schoolTitle: school.school_title,
          country: school.country,
          state: school.state,
          status: school.status,
          lat: school.lat,
          lng: school.lng,
          timezone: school.timezone,
          nickname: school.nickname,
          website: school.website,
          ncesCode: school.nces_code,
          ipedsId: school.ipeds_id,
          districtCode: school.district_code,
          districtName: school.district_name,
          primaryColor: school.primary_color,
          private: school.private,
          liteLevel: school.lite_level,
          alphabeticLunchWaves: school.alphabetic_lunch_waves,
          logo: school.logo && {
            id: school.logo.id,
            resourceUrl: school.logo.resource_url,
          },
        }}
        onSaved={() => {
          dispatch(schoolsActions.getSchoolById(school.school_name));
          onUpdated();
        }}
      />
    </MantineProvider>
  );
};

export default EditSchoolModal;
